const MNO_LOGO = {
  AIRTEL: '/static/images/logo/AIRTEL_LOGO.png',
  BSNL: '/static/images/logo/BSNL_LOGO.png',
  VI: '/static/images/logo/VI_LOGO.png'
};

export default MNO_LOGO;
